import { useEffect, useState } from "react";
import { ApiMonsterDetail, ApiResource, SourceDto, SpellDto, TranslatedText } from "../Types/ApiTypes";
import { addMonster, addSpell, getAllSources, getAllSpells } from "../Utils/LocalApi";
import { getDistanceFromFt, getTranslation } from "../Utils/Converters";



const ImportdataComponent = () =>{
    const [allSources, setAllSources] = useState([] as SourceDto[])
    const [allSpells, setAllSpells] = useState([] as SpellDto[])
        useEffect(() => {
            getAllSources().then(setAllSources);
            getAllSpells().then(setAllSpells);
        },[]);
    const [source, setSource] = useState({} as SourceDto);
    return(
        <>
            <div className="d-flex black justify-content-between px-4 py-2 header navbar text-white bg-dark">
            </div>
            <div className="d-flex">
                <span className="col-3 m-4">
                    <select 
                        value={source ? source.id : 0}
                        className="form-control"
                        name="index"
                        onChange={(e) => {
                            setSource(allSources.filter(s => {return s.id! === parseInt(e.target.value)})[0]);
                        }}
                    >
                        {allSources.map((source) => {
                            return(
                                <option key={source.id} value={source.id}>{(source.year > 0 ? source.year : "")+" "+getTranslation(source.name)}</option>
                            )
                        })}
                    </select>
                </span>

                <button className="btn btn-secondary m-4" onClick={e=>document.getElementById("file-input-spells")?.click()}>Import Spells</button>
                <input type="file"
                    style={{display: "none"}}
                    name="myFile"
                    id="file-input-spells"
                    onChange={async e=>{
                        if (e.target.files != null){
                            let file = e.target.files[0];
                            // console.log(file);
                            
                            if (file) {
                                importSpells(JSON.parse(await file.text()));
                            }
                        }
                    }} />
                    

                <button className="btn btn-secondary m-4" onClick={e=>document.getElementById("file-input-monsters")?.click()}>Import Monsters</button>
                <input type="file"
                    style={{display: "none"}}
                    name="myFile"
                    id="file-input-monsters"
                    onChange={async e=>{
                        if (e.target.files != null){
                            let file = e.target.files[0];
                            // console.log(file);
                            
                            if (file) {
                                importMonsters(JSON.parse(await file.text()));
                            }
                        }
                    }} />
            </div>
        </>
    );

    function importMonsters(file: any){
        console.log(file);
        file.forEach((monster: ApiMonsterDetail, index: number) => {
            // if (index === 0)
                
            let condition_immunities = "";
            if (monster.condition_immunities){
                (monster.condition_immunities.forEach((element, index) => {
                    condition_immunities += element.name;
                    if (index < monster.condition_immunities.length -1){
                        condition_immunities += "; ";
                    }
                }));
            }
            let speed = convertSpeed(monster.speed);
            let newMonster = {
                index: monster.index,
                // source: {} as SourceDto,
                name: {"en": monster.name}, 
                size: {"en": monster.size},
                type: {"en": monster.type},
                alignment: {"en": monster.alignment},
                armorClass: monster.armor_class ? monster.armor_class[0].value : 12,
                hitPoints: monster.hit_points, 
                hitDice: monster.hit_dice,
                hitPointsRoll: monster.hit_points_roll,
                walkDistance: speed.walk,
                flyDistance: speed.fly,
                swimDistance: speed.swim,
                climbDistance: speed.climb,
                burrowDistance: speed.burrow,
                otherDistance: {en: speed.other},
                statStr: monster.strength,
                statDex: monster.dexterity,
                statCon: monster.constitution,
                statInt: monster.intelligence,
                statWis: monster.wisdom,
                statCha: monster.charisma,
                saveStr: Math.round((monster.strength - 11)/2),
                saveDex: Math.round((monster.dexterity - 11)/2),
                saveCon: Math.round((monster.constitution - 11)/2),
                saveInt: Math.round((monster.intelligence - 11)/2),
                saveWis: Math.round((monster.wisdom - 11)/2),
                saveCha: Math.round((monster.charisma - 11)/2),
                skills: {en: ""},
                // initiativeBonus: monster.initiative?? Math.round((monster.dexterity - 11)/2),

                
                    
                hasSpellCasting: false,
                 
                damageVulnerabilities: {en: monster.damage_vulnerabilities.join('; ')},
                damageResistances: {en: monster.damage_resistances.join('; ')},
                damageImmunities: {en: monster.damage_immunities.join('; ')},
                conditionImmunities: {en: condition_immunities},
                languages:  {en: monster.languages},
                challenge: {en: "CR "+monster.challenge_rating+", "+monster.xp+" XP"},
                challengeCr: 0 as number,
                challengeXP: 0 as number,
                challengePB: 0 as number,
                passivePerception: monster.senses.passive_perception,
                darkvisionDistance: convertSense(monster.senses.darkvision ?? "").distance,
                blindsightDistance: convertSense(monster.senses.blindsight ?? "").distance,
                tremorsenseDistance: convertSense(monster.senses.tremorsense ?? "").distance,
                truesightDistance: convertSense(monster.senses.truesight ?? "").distance,
                darkvisionText: {en: convertSense(monster.senses.darkvision ?? "").text},
                blindsightText: {en: convertSense(monster.senses.blindsight ?? "").text},
                tremorsenseText: {en: convertSense(monster.senses.tremorsense ?? "").text},
                truesightText: {en: convertSense(monster.senses.truesight ?? "").text},
                proficiencyBonus: monster.proficiency_bonus,
                equipmentText: {en: ""},
                // equipment: [] as {title: string, description: string}[],
                reactionsText: {en: ""},
                reactions: [] as {title: TranslatedText, description: TranslatedText}[],
                traitsText: {en: ""},
                traits: [] as {title: TranslatedText, description: TranslatedText}[],
                actionsText: {en: ""},
                actions: [] as {title: TranslatedText, description: TranslatedText}[],
                bonusActionsText: {en: ""},
                bonusActions: [] as {title: TranslatedText, description: TranslatedText}[],
                legendaryActionsText: {en: ""},
                legendaryActions: [] as {title: TranslatedText, description: TranslatedText}[],

                spellCharacteristic: {en: ""},
                spellSave: 0,
                spellAttackMod: 0,
            
                spellGroups: [] as {
                        id?: number,
                        name: TranslatedText,
                        hasSlotsGroup: boolean,
                        hasSlotsEach: boolean,
                        maxSlots: number,
                        spells: SpellDto[]
                    }[]
            };
    
            monster.special_abilities && monster.special_abilities.forEach(element => {
                if (element.spellcasting){
                    newMonster.hasSpellCasting = true;
                    newMonster.spellCharacteristic = {en: element.spellcasting.ability.name};
                    newMonster.spellSave = element.spellcasting.dc;
                    newMonster.spellAttackMod = element.spellcasting.modifier;
                    newMonster.spellGroups = convert5eSrdSpellcasting(element.spellcasting).spellGroups;
                }
                else{
                    // newMonster.hasSpellCasting = false;
                    newMonster.traits.push({title: {en: element.name}, description: {en: element.desc}});
                }
            });
            
            monster.actions &&  monster.actions.forEach(element => {
                newMonster.actions.push({title: {en: element.name}, description: {en: element.desc}});
            });
    
            monster.reactions && monster.reactions.forEach(element => {
                newMonster.reactions.push({title: {en: element.name}, description: {en: element.desc}});
            });
    
            monster.legendary_actions && monster.legendary_actions.forEach(element => {
                newMonster.legendaryActions.push({title: {en: element.name}, description: {en: element.desc}});
            });        
    
            let proficiencies = "";
            if (monster.proficiencies){
                monster.proficiencies.map((prof, i)=>{
                    if (prof.proficiency.index.includes("saving-throw")){
                        let stat = prof.proficiency.index.split("-")[2];
                        switch (stat){
                            case "str":
                                newMonster.saveStr = prof.value;
                                break;
                            case "dex":
                                newMonster.saveDex = prof.value;
                                break;
                            case "con":
                                newMonster.saveCon = prof.value;
                                break;
                            case "int":
                                newMonster.saveInt = prof.value;
                                break;
                            case "wis":
                                newMonster.saveWis = prof.value;
                                break;
                            case "cha":
                                newMonster.saveCha = prof.value;
                                break;
                        }
                    }
                    else{
                        proficiencies+= prof.proficiency.name.split(": ")[1]+" "+(prof.value >= 0 ? "+" : "") + prof.value;
                        if (i < monster.proficiencies.length -1){
                            proficiencies += ", ";
                        }
                    }   
                    return null;
                });
            }
            newMonster.skills = {en: proficiencies};


            addMonster(newMonster).then(response => console.log(response));
            //save monster

        
        })
    }


    function importSpells(file: any){
        console.log(file);
        file.forEach((element: { index: any; desc: any[]; higher_level: any[]; name: any; range: any; components: string | string[]; material: any; ritual: any; duration: any; concentration: any; casting_time: any; level: any; attack_type: any; damage: { damage_type: { name: any; }; }; dc: { dc_type: { name: any; }; dc_success: any; }; area_of_effect: { type: any; size: any; }; school: any; classes: any[]; subclasses: any[]; }) => {
            let classes = ""
            element.classes.forEach((el, index) => {
                classes += el.name;
                if (index < element.classes.length -1){
                    classes += ", ";
                }  
            });
            let subclasses = "";
            element.subclasses.forEach((el, index) => {
                subclasses += el.name;
                if (index < element.subclasses.length -1){
                    subclasses += ", ";
                } 
            });
            
            let ftSize = element.area_of_effect ? element.area_of_effect.size: 0;
            let areaOfEffectSize ={
                ft: ftSize,
                sq: ftSize / 5,
                mt: (ftSize / 5) * 1.5
            }


            let range = {"ft": 0, "mt": 0, "sq": 0};
            let otherRange = "";
            if (element.range.includes("feet")){
                let ftRange = parseFloat(element.range.split(" ")[0])
                range = {
                    ft: ftRange,
                    sq: ftRange / 5,
                    mt: (ftRange / 5) * 1.5,
                }
            }else{
                range = {
                    ft: 0,
                    mt: 0,
                    sq: 0
                }
                otherRange = element.range;
            }
            
            // const requestOptions = {
            //     method: 'POST',
            //     headers: { 'Content-Type': 'application/json' },
            //     body: JSON.stringify(
                let spell =    {
                        "index": element.index,
                        // "source": source,
                        "description": {"en":element.desc.join("")},
                        "higherLevel": {"en":element.higher_level ? element.higher_level.join(""):""},
                        "name": {"en": element.name},
                        "range": range,
                        "otherRange": {"en": otherRange},
                        "components": {
                            "v": element.components.includes("V"),
                            "s": false,
                            "m": true
                            },
                        "materials": {"en": element.material},
                        "ritual": element.ritual,
                        "duration": {"en": element.duration},
                        "concentration": element.concentration,
                        "castingTime": {"en": element.casting_time},
                        "level": element.level,
                        "attackType": {"en": element.attack_type},
                        "damageType": {"en": element.damage? element.damage.damage_type ? element.damage.damage_type.name : "" : ""},
                        "dcType": {"en": element.dc? element.dc.dc_type.name : ""},
                        "dcSuccess": {"en": element.dc? element.dc.dc_success : ""},
                        "areaOfEffectType": {"en": element.area_of_effect? element.area_of_effect.type : ""},
                        "areaOfEffectSize":  areaOfEffectSize,
                        "school": {"en": element.school.name},
                        "classes": {"en": classes},
                        "subclasses": {"en": subclasses}
                    }
                // )
                
                //JSON.stringify({ title: 'React POST Request Example' })
            // };
            // fetch('http://localhost:8080/spells/', requestOptions)
            addSpell(spell)
                .then(response => console.log)
        });
        
            // .then(data => this.setState({ postId: data.id }));
    }


    function convertSpeed(speed: {
        walk: string,
        fly: string,
        swim: string,
        climb: string,
        burrow: string
    }) {
        let walkSpeedFt = speed.walk && speed.walk.includes("ft.") ? parseFloat(speed.walk.split(" ")[0]) : 0;
        let flySpeedFt = speed.fly && speed.fly.includes("ft.") ? parseFloat(speed.fly.split(" ")[0]) : 0;
        let swimSpeedFt = speed.swim && speed.swim.includes("ft.") ? parseFloat(speed.swim.split(" ")[0]) : 0;
        let climbSpeedFt = speed.climb && speed.climb.includes("ft.") ? parseFloat(speed.climb.split(" ")[0]) : 0;
        let burrowSpeedFt = speed.burrow && speed.burrow.includes("ft.") ? parseFloat(speed.burrow.split(" ")[0]) : 0;
        return {
            walk: getDistanceFromFt(walkSpeedFt),
            fly: getDistanceFromFt(flySpeedFt),
            swim: getDistanceFromFt(swimSpeedFt),
            climb: getDistanceFromFt(climbSpeedFt),
            burrow: getDistanceFromFt(burrowSpeedFt),
            other: ""
        }
    };

    function convertSense(sense: string){
        let [distance, ...text] = sense.split("ft.");

        return {
            distance: getDistanceFromFt(sense.includes("ft.") ? parseFloat(distance) : 0),
            text: sense.includes("ft.") ? (text.length > 1 ? text.join("ft.") : text.length > 0 ? text.join("") : sense) : ""
        }
    }


    function convert5eSrdSpellcasting(
        spellcasting: { level: number; ability: ApiResource; dc: number; modifier: number; components_required: string[]; school: string; slots: { 1: number; 2: number; 3: number; 4: number; 5: number; 6: number; 7: number; 8: number; 9: number; }; spells: {name: string,level: number,url: string,usage: {type: string,times: number,rest_types: string[]}}[]; id: string; }
    ): { spellCharacteristic: string; spellSave: number; spellAttackMod: number; spellGroups: {
        id?: number,
        name: TranslatedText,
        hasSlotsGroup: boolean,
        hasSlotsEach: boolean,
        maxSlots: number,
        spells: SpellDto[]
    }[]; } {
        let newSpellcasting = {
            spellCharacteristic: spellcasting.ability ? spellcasting.ability.name : "",
            spellSave: spellcasting.dc ?? 0,
            spellAttackMod: spellcasting.modifier ?? 0,
            spellGroups: [] as {
                id?: number,
                name: TranslatedText,
                hasSlotsGroup: boolean,
                hasSlotsEach: boolean,
                maxSlots: number,
                spells: SpellDto[]
            }[]
        };

        if (spellcasting.slots){
            newSpellcasting.spellGroups.push({
                name: {en: "Cantrips"},
                hasSlotsGroup:false,
                hasSlotsEach: false,
                // remainingSlots: 0,
                maxSlots: 0,
                spells: [] as SpellDto[]
            });

            //create groups
            for (let i=1 as keyof {1: number;2: number;3: number;4: number;5: number;6: number;7: number;8: number;9: number;}; i<= 9; i++){
                if (spellcasting.slots[i]){
                    newSpellcasting.spellGroups.push({
                        name: {en: "Level "+i},
                        hasSlotsGroup:true,
                        hasSlotsEach: false,
                        maxSlots: spellcasting.slots[i],
                        spells: [] as SpellDto[]
                    });
                }
            }
            spellcasting.spells.forEach(element =>{
                let splitUrl = element.url.split("/");
                let ind = (splitUrl[splitUrl.length -1]);
                for(let i=0; i< allSpells.length; i++){
                    if (ind === allSpells[i].index){
                        newSpellcasting.spellGroups[element.level].spells.push(allSpells[i]);
                        break;
                    }
                }
            });
        }
        else{
            //create groups
            spellcasting.spells.forEach(element =>{
                let foundGroup = false;
                    for (let i=0; i< newSpellcasting.spellGroups.length; i++){
                        if (newSpellcasting.spellGroups[i].name.en === (element.usage.times ? element.usage.times+" "+element.usage.type : element.usage.type)){
                            foundGroup = true;
                            break;
                        }
                    }
                    if (!foundGroup){
                        newSpellcasting.spellGroups.push({
                            name: {en: (element.usage.times ? element.usage.times+" "+element.usage.type : element.usage.type)},
                            hasSlotsGroup:false,
                            hasSlotsEach: element.usage.times ? true : false,
                            maxSlots: element.usage.times ?? 0,
                            spells: [] as SpellDto[]
                        })
                    }          

            });

            //add spells
            spellcasting.spells.forEach(element =>{
                let splitUrl = element.url.split("/");
                let ind = (splitUrl[splitUrl.length -1]);
                for(let j=0; j< allSpells.length; j++){
                    if (ind === allSpells[j].index){
                        let newSpell = (allSpells[j]);
                        for (let i=0; i< newSpellcasting.spellGroups.length; i++){
                            if (newSpellcasting.spellGroups[i].name.en === (element.usage.times ? element.usage.times+" "+element.usage.type : element.usage.type)){
                                newSpellcasting.spellGroups[i].spells.push(newSpell);
                                
                                // getSpellByIndex(
                                //     splitUrl[splitUrl.length -1]).then(
                                //         (spell: SpellDto) => props.addSpell(props.nextMonsterIndex, i, convertSpell(spell)))
                                //         ;
                                
                                
                                
                                break;
                            }
                        }
                        break;
                    }
                }
            })
        }
        return newSpellcasting;
    } 
}

export default ImportdataComponent;